import { useNavigate } from 'react-router-dom';
import { ROUTE_PACKAGE_FULL_URL } from '@src/constants/URLS.const';
import { CountryCard } from './components';

export function CountryList({ countries }: Readonly<{ countries: any[] }>) {
  const navigate = useNavigate();

  const handleSelectCountry = (countryId: string) => {
    navigate(`${ROUTE_PACKAGE_FULL_URL}?countryId=${countryId}`);
  };
  return (
    <div className='grid gap-x-6 grid-cols-[repeat(auto-fit,minmax(260px,1fr))]'>
      {countries.map((country) => (
        <button
          className='w-full mb-6'
          key={country.id}
          onClick={() => handleSelectCountry(country.id)}
        >
          <CountryCard country={country} />
        </button>
      ))}
    </div>
  );
}
